import { render, staticRenderFns } from "./Booking.vue?vue&type=template&id=21bdee15"
import script from "./Booking.vue?vue&type=script&lang=ts"
export * from "./Booking.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports